import { combineReducers } from 'redux';
import { items } from './items';

const subNav = combineReducers({
    items
});

export default subNav;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js